// src/components/Reports/FeedCard.tsx
import {
    HStack,
    VStack,
    Text,
    Image,
    Wrap,
    WrapItem,
    Box,
  } from "@chakra-ui/react"

import { ActionsMenu } from "@/components/Common/ActionsMenu"
import { type FeedMetadataPublic } from "@/client"

import { parse } from "date-fns"
import { ko } from "date-fns/locale"
import { formatInTimeZone } from "date-fns-tz"

interface FeedCardProps {
feeds: FeedMetadataPublic[]
onClick: (id: string) => void
}

function formatRSSDate(dateStr: string | null | undefined): string {
    if (!dateStr) return ""
    try {
        // ISO 8601 형식인지 우선 시도 (ex: 2025-06-19T17:17:04+09:00)
        const isoDate = new Date(dateStr)
        if (!isNaN(isoDate.getTime())) {
            return formatInTimeZone(isoDate, "Asia/Seoul", "yy/MM/dd (EEE) a h:mm", { locale: ko })
        }

        // ISO 파싱 실패 시 기존 포맷으로 시도 (ex: "Thu, 19 Jun 2025 17:17:04 +0900")
        const parsed = parse(dateStr, "EEE, dd LLL yyyy HH:mm:ss xxxx", new Date())
        return formatInTimeZone(parsed, "Asia/Seoul", "yy/MM/dd (EEE) a h:mm", { locale: ko })
    } catch {
      return dateStr
    }
  }

const FeedCard = ({ feeds, onClick }: FeedCardProps) => {
return (
    <Wrap gap={4}>
        {feeds.map((feed) => {
            const faviconUrl = `https://www.google.com/s2/favicons?domain_url=${feed.feed_url}&sz=64`
            return (
                <WrapItem key={feed.id}>
                    <HStack
                        gap={4}
                        bg="white"
                        borderRadius="3xl"
                        height="48px"
                        px={4}
                        py={2}
                        boxShadow="sm"
                        border="1px solid #e2e8f0"
                        align="center"
                        cursor="pointer"
                        _hover={{
                            boxShadow: "md",
                            transform: "scale(1.02)",
                            transition: "all 0.2s",
                        }}
                        onClick={() => onClick(feed.id)}
                    >
                        <Image
                            src={faviconUrl}
                            boxSize="32px"
                            borderRadius="md"
                            alt="favicon"
                        />
                        <VStack align="start" gap={0} maxW="300px">
                            <Text fontWeight="bold" fontSize="sm" maxW="100%"
                                whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis"
                            >
                                {feed.feed_name} -{" "}
                                <Box as="span" fontWeight="normal" fontSize="xs" color="gray.600">
                                    {feed.feed_description}
                                </Box>
                            </Text>
                            <Text fontSize="xs" color="gray.600">
                                최신 발행일: {formatRSSDate(feed.rss_last_build_date)}
                            </Text>
                        </VStack>

                        <Box onClick={(e) => e.stopPropagation()}>
                            <ActionsMenu feed={feed} />
                        </Box>
                    </HStack>
                </WrapItem>
            )
        })}
    </Wrap>
)
}

export default FeedCard
  